import { useUpdatePracticeDetail } from '../../../../../hooks/usePracticeDetail';
import { useToast } from '../../../../../providers/ToastProvider';
import { apiErrorMessage } from '../../../../../utils/apiError';

export type DmLinkSave = (doctorId: number, dmPracticeId: number) => Promise<boolean>;

// The PATCH writes only practice_monday_data, so the practice's updatedAt (the
// Details form's reset stamp) stays put and other unsaved edits survive the refresh.
export function useDmLinkSave(practiceId: string, onLinked: () => void) {
    const { showToast } = useToast();
    const update = useUpdatePracticeDetail(practiceId);

    const save: DmLinkSave = async (doctorId, dmPracticeId) => {
        try {
            await update.mutateAsync({
                account: { dmDoctorId: String(doctorId), dmPracticeId: String(dmPracticeId) }
            });
            showToast(`Linked DM doctor #${doctorId} and practice #${dmPracticeId}`, 'success');
            onLinked();
            return true;
        } catch (error) {
            showToast(apiErrorMessage(error, 'Failed to save the DM ids'), 'error');
            return false;
        }
    };

    return { save, isSaving: update.isPending };
}
